import React, { FC } from 'react'
import { VideoRecordingFilters } from '../style'

type Category = {
  label: string
  count: number
}

type CategoryFilterData = {
  allRecordings: string
  selectedCategory: string
  groupedRecordings?: Category[]
  filterCategoryData: (category: string) => void
}

type CategoryFilterDataProps = {
  categoryFilterData: CategoryFilterData
}

const CategoryFilters: FC<CategoryFilterDataProps> = ({ categoryFilterData }) => {
  const {
    allRecordings,
    selectedCategory,
    groupedRecordings = [],
    filterCategoryData,
  } = categoryFilterData

  return (
    <VideoRecordingFilters className="Video__Recording-Filters">
      <div className="Category-Filters">
        <div
          className={`Category ${selectedCategory === allRecordings ? 'active' : ''}`}
          onClick={() => filterCategoryData(allRecordings)}>
          {allRecordings}
        </div>
        {groupedRecordings.map(category => (
          <div
            key={category?.label} // Add key to avoid React warning
            className={`Category ${selectedCategory === category?.label ? 'active' : ''}`}
            onClick={() => filterCategoryData(category?.label)}>
            {category?.label}
            <span> ({category?.count})</span>
          </div>
        ))}
      </div>
    </VideoRecordingFilters>
  )
}

export default CategoryFilters
